export default ClearInput = {
  mounted() {
    const clearButton = this.el;
    const inputToClear = document.querySelector(this.el.dataset.to);

    clearButton.addEventListener("click", (ev) => {
      inputToClear.value = "";
      inputToClear.dispatchEvent(new Event("change", { bubbles: true }));
    });
  },
};
